var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"popup_bg",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.close()}}},[_c('div',{class:{
        'popup': _vm.background === false,
        'popup-background': _vm.background === true,
      }},[_c('div',{staticClass:"popup-header"},[_vm._t("header")],2),_c('div',{staticClass:"popup-content"},[_vm._t("content")],2),_c('div',{staticClass:"popup-footer"},[_vm._t("footer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }